<template>
  <v-toolbar id="main-toolbar" v-if="authenticated" fixed app flat dark color="primary" extension-height="0" overflow>
    <v-toolbar-side-icon @click.stop="toggleDrawer" v-if="authenticated" ></v-toolbar-side-icon>
    
    <!-- Authenticated -->
    <template v-if="authenticated">
      <v-spacer></v-spacer>
      <!-- <progress-bar :show="busy"></progress-bar> -->
      <v-toolbar-title class="font-weight-thin body-1 pb-1"><v-icon class="hidden-sm-and-down">family_restroom</v-icon> {{ user.name }}</v-toolbar-title>
    </template>
    <!-- Guest -->
    <template v-else >
      <v-img height="90px" position="left left" contain :src="`${appUrl}/storage/img/logo_columbus.png`"></v-img>
      <v-btn flat :to="{ name: 'login' }">{{ $t('login') }}</v-btn>
      <v-btn v-if="showRegister" flat :to="{ name: 'register' }">{{ $t('register') }}</v-btn>
    </template>

    <template>
      <v-toolbar-items>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              flat
              class="white--text"
              v-on="on"
            >
              <v-icon class="mr-1">language</v-icon> {{ locale }}
            </v-btn>
          </template>
          <v-list id="language-list">
            <div
              v-for="(item, index) in langs"
              :key="index">
              <v-list-tile
                v-if="locale != item.value" 
                @click="locale != item.value ? setLanguage(item) : null"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <img :src="item.flag" />
                </v-list-tile-action>
              </v-list-tile>
            </div>            
          </v-list>
        </v-menu>
        <v-btn v-if="authenticated" flat @click.prevent="logout" class="font-weight-thin"><v-icon>logout</v-icon> <span  class="ml-1 hidden-sm-and-down">{{ $t('logout') }}</span></v-btn>
      </v-toolbar-items>
    </template>

    <v-progress-linear
      :active="busy"
      color="accent"
      slot="extension"
      :indeterminate="true"
      class="ma-0 mx-0"
      height="4"
      style="top: -2px; left: -5px; right: -5px"
    >Loading...</v-progress-linear>
  </v-toolbar>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },

  data: () => ({
    appName: window.config.appName,
    busy: false,
    appUrl: window.config.appUrl,
    langs: [
      {value: 'es', text: 'ES', flag: 'https://flagcdn.com/w20/co.png'},
      {value: 'en', text: 'EN', flag: 'https://flagcdn.com/w20/us.png'},
    ],
    lang: 'es',
    showRegister: false,
  }),

  created () {
    this.lang = this.locale;
    this.getConfiguration()
  },

  computed: mapGetters({
    user: 'authUser',
    authenticated: 'authCheck',
    page_loading: 'pageLoading',
    locale: 'locale'
  }),

  watch: {
    page_loading(newValue, oldValue) {
      this.busy = newValue
    },
    locale(newValue, oldValue) {
      this.lang = this.locale
    }
  },

  methods: {
    toggleDrawer () {
      this.$emit('toggleDrawer')
    },
    setLanguage(item){
      this.lang = item.value
      this.changeLocale()
    },
    async logout () {
      this.busy = true

      // Log out the user.
      await this.$store.dispatch('logout')
      this.busy = false

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },
    async changeLocale() {
      this.$store.commit('SET_LOCALE', this.lang)

      if (this.authenticated) {
        await axios.get(`/api/language/${this.lang}`)
        await this.$store.dispatch('fetchUser')
      }
      location.reload()
    },
    getConfiguration() {
      // axios.get('/api/configuration/APP_REGISTER')
      //   .then(resp => {
      //     if (resp.status === 200) {
      //       this.showRegister = resp.data.int_value === 1
      //     }
      //   })
      //   .catch(err => console.log(err))
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ToolBar.vue